export default "__VITE_ASSET__SdB$4OiA__"